module.exports = __webpack_public_path__ + "static/media/br-es.55b92af8.svg";